function Alert({ variant, ...props }) {
  return <span className={variant} {...props}></span>;
}

export default Alert;
